import { render, staticRenderFns } from "./Videojs.vue?vue&type=template&id=79e67a93&scoped=true&lang=pug&"
import script from "./Videojs.vue?vue&type=script&lang=js&"
export * from "./Videojs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e67a93",
  null
  
)

export default component.exports